import * as React from 'react'
import { PropsWithChildren, ReactElement } from 'react'
import { makeStyles, mergeClasses, shorthands, tokens } from '@fluentui/react-components'
import useViewport, { Viewport } from '../../../hooks/useViewport'

type Props = {
    sidePanel?: ReactElement
}

export const useFormContainerStyles = makeStyles({
    container: {
        display: 'grid',
        columnGap: tokens.spacingVerticalM,
        rowGap: tokens.spacingHorizontalM,
    },
    horizontal: {
        gridTemplateColumns: `3fr 2fr`,
    },
    vertical: {
        gridTemplateColumns: `1fr`,
    },
    body: {
        display: 'grid',
        ...shorthands.gap(tokens.spacingVerticalS),
    },
    sidePanel: {},
})

export default function FormContainer(props: PropsWithChildren<Props>): ReactElement {
    const { isViewport } = useViewport()
    const styles = useFormContainerStyles()

    return (
        <div
            className={mergeClasses(
                styles.container,
                isViewport('>=', Viewport.OutlookNewWide) && props.sidePanel ? styles.horizontal : styles.vertical,
            )}
        >
            <div className={styles.body}>{props.children}</div>
            {props.sidePanel && <div className={styles.sidePanel}>{props.sidePanel}</div>}
        </div>
    )
}
